"use strict";

(function () {
  'use strict';

  angular.module('payment-modal').directive('validCardType', validCardType);
  validCardType.$inject = [];
  /* @ngInject */

  function validCardType() {
    return {
      require: 'ngModel',
      scope: {
        validCardType: '<',
        cardType: '<'
      },
      link: function link(scope, element, attributes, ngModel) {
        scope.$watch('cardType', function (oldVal, newVal) {
          if (scope.cardType) {
            ngModel.$setValidity('invalidCCType', scope.validCardType.indexOf(scope.cardType.substring(0, 1).toUpperCase()) > -1);
          }
        });
      }
    };
  }
})();